import React, { useState, useEffect } from 'react';
import Form from "./Form";

// core components
import SimpleHeader from '../../../components/Headers/SimpleHeader';

export default ({ location, match, ...props }) => {

    const [id, setId] = useState(null)

    useEffect(() => {
        const { params } = match
        if (params && params.id != id) {
            setId(params.id)
        }
    }, [])

    return (
        <>
            <SimpleHeader
                name="Alterar Mala Direta"
                parentName="Malas Diretas"
                {...props} />
            <Form
                location={location}
                {...props}
                mala_direta_id={id}
                isEdit={true}
            />
        </>
    );
}